export default class {
  constructor() {
    this.listeners = [];
  }

  on(evt, listener) {
    if (Array.isArray(this.listeners[evt])) {
      this.listeners[evt].push(listener);
    } else {
      this.listeners[evt] = [listener];
    }
  }

  update(update) {
    this.listeners['update'].forEach((listener) => listener(update));
  }
}
